import * as React from "react";
import {useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ContainerBox} from "myshubhlife-component/container-box";
import {Button} from "web-com";
import {COLOR} from "utils/variables";
import {IScreens} from "IncompleteInfoV2/interface";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import {AddressFields} from "./addressFeilds";
import {IProfile} from "profile/interface";
import {getInitialResidenceValue, profileUpdate} from "IncompleteInfoV2/ResidenceAddress/utils";
import {validations} from "IncompleteInfoV2/validations";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import {updateSubStatuses} from "IncompleteInfoV2/api";
import {saveLamProfile} from "profile/api";
import {history} from "load/store";
import Loading from "components/loading";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    profile: IProfile;
    applicationId: number;
    isAndroid: boolean;
}

export interface IResidenceAddressFields {
    residentType: string;
    resTenure: string;
    street: string;
    house: string;
    locality: string;
    landmark: string;
    pincode: string;
}

const ResidenceAddress = (props: IConnectProps & RouteComponentProps) => {
    const [fields, updateFields] = useState<IResidenceAddressFields>(getInitialResidenceValue(props.profile));
    const [errors, setErrors] = useState<{[key: string]: string}>({});
    const [loading, setLoading] = useState(false);
    const handleSubmit = async () => {
        const validationStatus = validations(fields);
        if (Object.keys(validationStatus).length) {
            return setErrors(validationStatus);
        }
        if (!Object.keys(errors).length) {
            try {
                setLoading(true);
                const saveProfile  = await saveLamProfile(props.userId, profileUpdate(fields), null, null);
                if (saveProfile.status === 200) {
                    const removeStatus = await updateSubStatuses(props.applicationId, props.screens[ScreenNames.RESIDENCE_ADDRESS].subStatuses);
                    if (removeStatus.status === 200) {
                        props.dispatch(showToast(COLOR.GREEN, `${pageTitle.resiAddress} updated successfully`));
                        props.dispatch(removeCompletedSubStatus(ScreenNames.RESIDENCE_ADDRESS));
                        setLoading(false);
                        history.goBack();
                    }
                }
            } catch (err) {
                setLoading(false);
            }
        }
    };

    const handleChange = (fieldName: string, value: string) => {
        if (errors[fieldName]) {
            const {[fieldName]: removedValue, ...fieldErrors} = errors;
            setErrors({...fieldErrors});
        }
        updateFields((prevState) => {
            return {
                ...prevState,
                [fieldName]: value,
            };
        });
    };
    return (
        <ContainerBox
            backgroundColor={COLOR.WHITE}
            pageTitle={pageTitle.resiAddress}
            showBackButton={!props.isAndroid}
        >
            <Loading active={loading} msg={"Please wait we're making changes"} />
            <AddressFields
                fields={fields}
                onChange={handleChange}
                errors={errors}
            />
            <Button
                buttonText="Continue"
                onClick={handleSubmit}
                bgColor={COLOR.PRIMARY}
                width={"60%"}
            />
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        profile: state?.profileInfo?.paanduProfile,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
        isAndroid: state.login.isAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(ResidenceAddress);
